import { render, staticRenderFns } from "./recharge_dashboard.vue?vue&type=template&id=2b49942a"
import script from "./recharge_dashboard.vue?vue&type=script&lang=js"
export * from "./recharge_dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports